module.exports = __webpack_public_path__ + "static/home-man-in-space-f658fee9955d96a96e8ffaf60e5d7a57.jpg";